"use strict";

import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
document.addEventListener("DOMContentLoaded", () => {
  var lazyImages = document.getElementsByClassName("lazy");
  if (lazyImages.length === 0) return;
  var _loop = function _loop() {
    var lazyImage = img;
    /* The lazy loading is given by the attribute loading="lazy" of images! */
    lazyImage.onload = () => {
      var {
        currentSrc
      } = lazyImage;
      lazyImage.style.cssText = "display:none";
      /* Retrieving the parent */
      var parent = lazyImage.parentNode;
      parent.style.backgroundImage = "url(\"" + currentSrc + "\")";
    };
  };
  for (var img of lazyImages) {
    _loop();
  }
});